const apiBase = process.env.REACT_APP_API;

export const fetchPayments = async ( page = 1, limit = 10, courseId, search) => {
  try {
    const queryParams = new URLSearchParams({ page, limit });
    if (courseId) queryParams.append('courseId', courseId);
    if (search) queryParams.append('search', search);

    const response = await fetch(
      `${apiBase}/payments/bank?${queryParams.toString()}`
    );
    if (!response.ok) {
      throw new Error('Failed to fetch payment data');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching payment data:', error);
    throw error;
  }
};

export const updateBankPayment = async ({ email, status, paymentId, adminMsg }) => {
  const url = `${apiBase}/payments/bank/${paymentId}?status=${status}`;
  const payload = {
    adminMsg,
    email
  };

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Request failed: ${response.status} - ${error}`);
    }

    const data = await response.json();
    console.log("Response:", data);
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}
